export const VERSION = `v1`;
const host =  process.env.NODE_ENV === 'development' ? `api` : `${VERSION}`;

export const TRANSACTION_URL = `/${host}/transactions`;
export const GET_ACCOUNT_URL = `/${host}/accounts`;